const firebaseConfig = {
    apiKey: "AIzaSyA8BkCACMnfemoM7YV0OKpcGkyECHl1vTQ",
    authDomain: "crud-cefab.firebaseapp.com",
    projectId: "crud-cefab",
    storageBucket: "crud-cefab.appspot.com",
    messagingSenderId: "354313014801",
    appId: "1:354313014801:web:87102141e1033f47dc6bb0"
  };
  export default firebaseConfig